
import AppChatMessage from "@/components/chat/ChatMessage.vue";
import { ChatMessage } from "@/models/chat/chat-message";
import { Conversation } from "@/models/chat/conversation";
import { ConversationGroup } from "@/models/chat/conversation-group";
import { ChatService } from "@/services/chat-service";
import { ChatState } from "@/utils/chat-state";
import { Quill } from "quill";
import Vue from "vue";
import { MainSocketService } from "../../services/main-socket-service";


export default Vue.extend({
	data() {
		return {
			bubble: this.state.settings.BubbleStyle || true,
			msgInput: "",
			dragCount: 0,
			conversationGroups: [] as ConversationGroup[],
			message: "",
			file: null as null | File,
			ready: false,
			lastDate: 0,
			showAddThreadModal: false,
			customToolbar: [
				["bold", "italic", "code-block"],
				[{ list: "ordered" }, { list: "bullet" }]
			]
		};
	},
	props: {
		conversation: {
			type: Object as () => Conversation,
			required: true
		},
		state: {
			type: Object as () => ChatState,
			required: true
		}
	},
	computed: {
		isDragging(): boolean {
			return this.dragCount > 0;
		},
		editorSettings(): any {
			let _ = this;
			return {
				modules: {
					/*"emoji-toolbar": true,*/
					"emoji-textarea": true,
					"emoji-shortname": true,
					keyboard: {
						bindings: [
							{
								key: "enter",
								handler(this: { quill: Quill }) {
									_.sendMessage();
									this.quill.setContents([
										{ insert: "\n" }
									] as any);
									return false;
								}
							}
						]
					}
				}
			};
		}
	},
	methods: {
		onChange(e: any) {},
		toggleNewThread() {
			this.showAddThreadModal = true;
		},
		makeConversationGroups(): any {
			this.conversationGroups = [];
			let c = new ConversationGroup();
			let prevDays = 0;
			this.conversation.Messages.forEach(message => {
				const timeDiff =
					(new Date() as any) - (new Date(message.TimeStamp) as any);
				const days = Math.round(timeDiff / (1000 * 60 * 60 * 24));
				if (days < prevDays) {
					this.conversationGroups.push(c);
					c = new ConversationGroup();
					c.TimeStamp = message.TimeStamp;
					c.Seperator = this.conversationSeperator(
						days,
						message.TimeStamp
					);
				}
				c.Seperator = this.conversationSeperator(
					days,
					message.TimeStamp
				);
				c.Messages.push(message);
				prevDays = days;
			});
			if (c.Messages.length > 0) {
				this.conversationGroups.push(c);
			}
			return this.conversationGroups;
		},
		conversationSeperator(d: any, t: Date): string {
			if (d == 0) {
				return this.$ct("common.date.today").toString();
			}
			if (d == 1) {
				return this.$ct("common.date.yesterday").toString();
			}

			return t.toLocaleDateString("nl-be", {
				weekday: "short",
				year: "numeric",
				month: "2-digit",
				day: "2-digit"
			});
		},
		showDateSeperator(d: any): Date {
			const timeDiff = (new Date() as any) - (new Date(d) as any);
			const days = timeDiff / (1000 * 60 * 60 * 24);
			if (days >= 1) {
				return d;
			}
			return d;
		},
		async sendMessage() {
			if (!this.message && !this.file) return;

			await ChatService.postMessage(
				this.conversation.ID,
				this.message,
				this.file
			);
			this.message = "";
			this.file = null;
		},
		focus() {
			setTimeout(() => {
				let el = this.$refs.messagebox as HTMLInputElement;
				el.focus();
			}, 200);
		},
		onNewMessage(message: any) {
			this.conversation.Messages.push(new ChatMessage(message));
			this.fetch();
		},
		onDragStart() {
			this.dragCount++;
		},
		onDragEnd() {
			this.dragCount--;
		},
		async onFileDrop(event: DragEvent) {
			this.dragCount = 0;
			if (!event.dataTransfer) {
				return;
			}
			if (event.dataTransfer.files.length == 0) {
				return;
			}
			let files = [] as File[];
			for (let file of event.dataTransfer.files) {
				files.push(file);
			}
			//let result = await TicketService.sendMessage(this.ticket.id, "", files);
		},
		scrollBottom() {
			var container = this.$el.querySelector(".w-card-content.messages");
			if (container) {
				container.scrollTop = container.scrollHeight;
			}
		},
		async fetch() {
			if (!this.conversation) return;

			this.makeConversationGroups();
			this.ready = true;
			await this.$nextTick();
			this.scrollBottom();
		}
	},
	beforeDestroy() {
		MainSocketService.offAll(this);
	},
	async mounted() {
		await this.fetch();
		this.scrollBottom();
	},
	async created() {
		MainSocketService.on(`/chat/conversation/${this.conversation.ID}/message/new`, this.onNewMessage, this);
	},
	components: {
		AppChatMessage,
		VueEditor: () => import("@/utils/vue-editor")
	},
	i18nEx: {
		componentPrefix: "components.chat-ChatConversation"
	}
});
